export function isVisible(el) {
  return window.getComputedStyle(el).display !== 'none';
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/isVisible.js